import { LanguageSelector } from '@jotta/ui/LanguageSelector'
import { PaymentSummary } from './PaymentSummary'
import { useBreakpointIndex } from '@jotta/ui/useBreakpointIndex'
import type { ReactNode } from 'react'
import type { Offer } from '@jotta/grpc-connect-openapi/offer'
import type { RecurringSubscriptionInterval } from '@jotta/grpc-connect-openapi/payment'
import { PlainBrandIcon } from '@jotta/ui/BrandIcon'
import SvgInfo from '@jotta/ui/SvgInfo'

export function PaymentLayout({
  children,
  title,
  interval,
  backPath,
  backElement,
  progressIndicator,
  offer,
}: {
  children: (summary: ReactNode) => ReactNode
  offer: Offer
  title: string
  backPath: string
  backElement: ReactNode
  progressIndicator?: ReactNode
  interval: RecurringSubscriptionInterval
}) {
  const wideLayout = useBreakpointIndex() > 1
  return (
    <div className="grid min-h-full w-full grid-cols-1 bg-white lg:grid-cols-2">
      <div className="flex w-full max-w-2xl flex-col justify-self-center p-6 md:p-[88px] lg:justify-self-end">
        <div className="flex justify-between pb-10">
          <a href={backPath}>{backElement}</a>
          {!wideLayout && <LanguageSelector />}
        </div>
        {offer.checkoutNoticeLocalized && (
          <div className="pt-4">
            <div className="rounded-lg border border-informative bg-informative">
              <div className="flex gap-2 px-4 py-3">
                <PlainBrandIcon
                  icon={SvgInfo}
                  height={24}
                  width={24}
                  className="flex-shrink-0 text-informative"
                />
                <div className="body-sm-ln flex-grow">
                  {offer.checkoutNoticeLocalized}
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="flex flex-col gap-8 pb-6 pt-12">
          {progressIndicator && <div>{progressIndicator}</div>}
          <h1 className="title-lg">{title}</h1>
        </div>
        {children(
          wideLayout ? undefined : (
            <>
              <hr className="my-4" />
              <div className="rounded-md bg-signup-background-right p-8">
                <PaymentSummary offer={offer} interval={interval} />
              </div>
            </>
          ),
        )}
      </div>
      {wideLayout && offer && (
        <div className="bg-signup-background-right p-[88px]">
          {wideLayout && <LanguageSelector className="float-right" />}
          <PaymentSummary
            className="max-w-screen-sm pb-44 pt-[144px]"
            offer={offer}
            interval={interval}
          />
        </div>
      )}
    </div>
  )
}
